export const environment = {
  production: false,
  sgcApi: 'https://ar-az-es-euw-q-appext-pkceapi.azurewebsites.net/sgcapi/',
  reportApi: 'https://ar-az-es-euw-q-appext-pkceapi.azurewebsites.net/reportapi/',
  sgc1Url: 'https://sgc-qa.aramark.es/sgc/',
  apiVersion: 'v1',
  sgcClientId: 'Tsw8Xf27m0u57j2EBXbiCXCedsOuM2cn',
  sgcKeyWord: 'N3tOkQm3nuKyFn7EU3Goz1Het3Ob68aZ',
};
